import { Timestamp, addDoc, collection } from 'firebase/firestore';
import { firestore } from '@/utils/firebase';

export const AUDIT_ACTIONS_COLLECTION = 'auditActions';

const toSerializableValue = (value) => {
	if (value == null) return null;
	if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
		return value;
	}
	try {
		return JSON.parse(JSON.stringify(value));
	} catch {
		return String(value);
	}
};

/**
 * Persists an action to the shared auditActions collection (no Folio UI yet).
 * One document per changed field. Ask AI audits stay separate for now.
 */
export const logAuditActions = async ({
	actionType,
	performedBy,
	targetUser,
	changedFields = {},
	previousValues = {},
}) => {
	const fieldEntries = Object.entries(changedFields ?? {}).filter(
		([field]) => field !== 'lastUpdated' && field !== 'lastUpdatedBy',
	);

	if (fieldEntries.length === 0) {
		return [];
	}

	const performedByPayload = {
		userId: performedBy?.userId ? String(performedBy.userId) : null,
		hubspotId: performedBy?.hubspotId ?? null,
		email: performedBy?.email ?? null,
		name: performedBy?.name ?? null,
	};

	const targetUserPayload = {
		userId: targetUser?.userId ? String(targetUser.userId) : null,
		hubspotId: targetUser?.hubspotId ?? null,
		email: targetUser?.email ?? null,
		name: targetUser?.name ?? null,
	};

	const timestamp = Timestamp.now();
	const writes = fieldEntries.map(([fieldChanged, newValue]) =>
		addDoc(collection(firestore, AUDIT_ACTIONS_COLLECTION), {
			timestamp,
			actionType,
			fieldChanged,
			performedBy: performedByPayload,
			targetUser: targetUserPayload,
			previousValue: toSerializableValue(previousValues?.[fieldChanged]),
			newValue: toSerializableValue(newValue),
		}),
	);

	return Promise.all(writes);
};
